import { PRODUCT_ACTIVITY_TYPE_TEXT } from '@consts/products';
import { DeepLinkActions, useDeeplink } from '@hooks/deeplink';
import { ProductModel } from '@models/product';
import { cdnImageUrl } from '@utils/image';
import React from 'react';

export interface ProductLinkButtonProps {
  product?: Partial<ProductModel>;
  source?: string;
}

export const ProductLinkButton: React.FC<ProductLinkButtonProps> = (props) => {
  const { linkTo } = useDeeplink();
  const { product, source } = props;
  return (
    <button
      className="link-button"
      style={{
        height: '52px',
        display: 'flex',
        gap: '12px',
        margin: '0 20px',
        border: '1px solid #EFF1F4',
        textAlign: 'left',
        alignItems: 'center',
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        linkTo(
          {
            action: DeepLinkActions.GO_TO_PRODUCT,
            payload: { productId: product?._id },
          },
          { source: source },
        );
      }}>
      {product?.thumbnailImage && (
        <img
          src={cdnImageUrl(product?.thumbnailImage)}
          alt=""
          style={{
            height: '52px',
            width: '52px',
            objectFit: 'cover',
            display: 'bolck',
          }}
        />
      )}
      <div
        style={{
          width: 'calc(100% - 108px)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <div
          style={{
            wordBreak: 'break-word',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            color: 'var(--Neutral-90, #424242)',
            fontFamily: 'Pretendard',
            fontSize: '13px',
            fontStyle: 'normal',
            fontWeight: 400,
          }}>
          {product?.title}
        </div>
        {(product?.sellerName || product?.activityType || product?.favoritedCount) && (
          <div
            style={{
              display: 'flex',
              gap: '6px',
              color: 'var(--Neutral-60, #9B9DA0)',
              fontFamily: 'Pretendard',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 500,
              marginTop: '4px',
            }}>
            {product?.sellerName && <div>{product?.sellerName}</div>}
            {product?.sellerName && <div style={{ width: '1px', height: '14px', background: '#E8EAED' }}></div>}
            {product?.activityType && <div>{PRODUCT_ACTIVITY_TYPE_TEXT[product?.activityType]?.title}</div>}
            {product?.activityType && <div style={{ width: '1px', height: '14px', background: '#E8EAED' }}></div>}
            {product?.favoritedCount && product?.favoritedCount > 0 && <div>{`찜 ${product?.favoritedCount}개`}</div>}
          </div>
        )}
      </div>
    </button>
  );
};

export default ProductLinkButton;
